import { useRef } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FlowsService } from "../../services/FlowsServices";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import { AlertService } from "../../services/Alert";
import { useNavigate } from "react-router-dom";
import useModal from "../../hooks/useModal";
import Input from "../../components/form-controls/Input";
import Button from "../../components/form-controls/Button";

interface ModalAddNumberProps {
    showModalLink: boolean;
    onRequestClose: (refresh: boolean) => void;
}

const FlowPartial = ({ showModalLink, onRequestClose }: ModalAddNumberProps) => {
    const { t } = useTranslation();
    const { account } = useCurrentAccount();
    const navigate = useNavigate();
    const modalAddNumber = useRef<HTMLDivElement>(null);

    useModal(modalAddNumber, showModalLink)
    const defaultValues = {
        name: ''
    }

    const { register, handleSubmit, reset, watch, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });


    const submit = async (data: any) => {
        const confirmed = await AlertService.warning(
            t('campaigns.response-flow.alert-add-flow'),
            `${t('campaigns.response-flow.alert-add-flow-text')}${data.name}?`,
            () => Promise.resolve(),
            t('campaigns.response-flow.btn-accept'),
        );
        if (!confirmed) return;
        try {
            const response = await FlowsService.addFlows(data.name, account.id);
            AlertService.toastSuccess(t('campaigns.response-flow.success'));
            const info_bot = {
                version: "3.0",
                token: "",
                status: response.data.status,
                status_id: "",
                bot_id: response.data._id,
                name: response.data.name,
                account_id: account.id,
                bot_version_production: "3.0"
            };
            onRequestClose(true);
            reset(defaultValues);
            setTimeout(() => {
                navigate(`/campaigns/builder`, {
                    state:
                    {
                        account_id: account.id,
                        formData: data,
                        info_bot: info_bot
                    }

                });
                AlertService.toastSuccess(t('campaigns.response-flow.new-config'));
            }, 400);
        } catch (error: any) {
            console.error(
                t('campaigns.response-flow.error-flow'),
                error,
            );

            AlertService.toastError(
                `${t('campaigns.response-flow.error-flow-no-register')} ${error}.`,
            );
        }
    }

    const resetForm = () => {
        onRequestClose(false);
        reset();
    };

    return (
        <div className="modal fade" ref={modalAddNumber} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{t('campaigns.response-flow.form-title')}</h4>
                            <button title="close-modal" type="button" className="btn-close" onClick={() => resetForm()}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <Input
                                    label={t('campaigns.response-flow.label')}
                                    placeholder={t('campaigns.response-flow.placeholder')}
                                    errors={errors?.name}
                                    {...register('name', {
                                        required: true,
                                        setValueAs: (value) => value.trim()
                                    })}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => resetForm()}>{t("btn-cancel")}</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t('btn-continue')}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default FlowPartial
